/* eslint-disable max-lines-per-function */
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import CopyIcon from '@material-ui/icons/FileCopy'; // FIXME: replace with content copy icon with mui upgrade
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';
import React from 'react';
import {Notification} from '../classes/Notification';
import locale from '../locale/Localization';

export default function PasswordField(props) {
  const {label, value} = props;
  const [showPassword, setShowPassword] = React.useState(false);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => event.preventDefault();

  const copyToClipboard = async (id: string) => {
    try {
      const permissions = await navigator.permissions.query({
        name: 'clipboard-write'
      });
      if (permissions.state === 'granted' || permissions.state === 'prompt') {
        const inputValue = document.getElementById(id);
        await navigator.clipboard.writeText(inputValue.value);

        if (props.addNotification) {
          console.log('add notification');
          props.addNotification([
            new Notification(locale.copyToClipBoardSuccess, 'success', 6000)
          ]);
        }
      } else {
        if (props.addNotification) {
          props.addNotification([
            new Notification(
              locale.copyToClipboardErrorPermission,
              'error',
              6000
            )
          ]);
        } else {
          throw new Error(locale.copyToClipboardErrorPermission);
        }
      }
    } catch (error) {
      if (props.addNotification) {
        props.addNotification([
          new Notification(locale.copyToClipboardError, 'error', 6000)
        ]);
      } else {
        throw new Error(locale.copyToClipboardError);
      }
    }
  };

  const id = 'seal-' + label;
  return (
    <FormControl sx={{m: 1, width: '25ch'}} variant='standard'>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Input
        id={id}
        type={showPassword ? 'text' : 'password'}
        value={value}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={() => setShowPassword((show) => !show)}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
            <IconButton
              aria-label='copy to clipboard'
              onClick={() => copyToClipboard(id)}
              size='small'
            >
              <CopyIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
}

PasswordField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  addNotification: PropTypes.func
};
